var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact-us"},[_c('a',{attrs:{"href":`tel:${_vm.supplierPhone}`}},[_vm._v("Having trouble? Call "+_vm._s(_vm.supplierName)+" on "),_c('b',[_vm._v(_vm._s(_vm.supplierPhone))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }